import { DateRange } from 'bold-ui'
import { isEqual as isEqualDateFns } from 'date-fns'
import { isUndefinedOrNull } from 'util/checks'
import { toDate } from 'util/date/formatDate'

import { DateRangeFieldType, isDateRange, isLocalDateRange, LocalDateRange } from './model-dateRange'

/**
 * Essa função foi criada devido ao fato do final-form usar o Shallow Equal
 * para verificar se um campo é igual ao outro para computar o valor de 'dirty'
 * e também compara com os initial values para computar o 'pristine'
 * Ref: https://final-form.org/docs/react-final-form/types/FieldProps#isequal
 * Como no caso das datas é sempre criado um objeto novo, o campo é considerado 'dirty' ou 'not pristine' mesmo que os ranges
 * tenham valores iguais por causa do Shallow Equal
 */
export const isDateRangeFieldEqual = (dateA: DateRangeFieldType, dateB: DateRangeFieldType): boolean => {
  if (isLocalDateRange(dateA) && isLocalDateRange(dateB)) {
    return isDateRangeIgual(toDateRange(dateA), toDateRange(dateB))
  }

  if (isDateRange(dateA) && isDateRange(dateB)) {
    return isDateRangeIgual(dateA, dateB)
  }

  if (isDeepNullish(dateA) && isDeepNullish(dateB)) {
    return true
  }

  return false
}

const isDateRangeIgual = (dateA: DateRange, dateB: DateRange): boolean => {
  const { startDate: startDateA, endDate: endDateA } = dateA ?? {}
  const { startDate: startDateB, endDate: endDateB } = dateB ?? {}

  return (
    ((isUndefinedOrNull(startDateA) && isUndefinedOrNull(startDateB)) || isEqualDateFns(startDateA, startDateB)) &&
    ((isUndefinedOrNull(endDateA) && isUndefinedOrNull(endDateB)) || isEqualDateFns(endDateA, endDateB))
  )
}

const toDateRange = (localDateRange: LocalDateRange): DateRange => ({
  startDate: toDate(localDateRange?.startDate),
  endDate: toDate(localDateRange?.endDate),
})

const isDeepNullish = (date: DateRangeFieldType): boolean =>
  isUndefinedOrNull(date) || (isUndefinedOrNull(date.startDate) && isUndefinedOrNull(date.endDate))
